export const FeaturesList = [
    "clientDisclosures",
    "clientReferralSourceView",
    "customReportsDownload",
    "customReportsSchedule",
    "customReportsUnlimitedSave",
    "customRoles",
    "discreteLicenseeField",
    "discreteLicenseRecords",
    "enhancedSentMessageView",
    "fax",
    "hostedIntakeFormCustomizable",
    "hostedIntakeFormUnlimited",
    "hostedIntakeFormExisting",
    "hostedIntakeFormFileUpload",
    "integrationAccounts",
    "quickbooks",
    "signwiseUnlimited",
    "workflows",
    "customizeClientStatus",
    "simpleSearch",
    "mailboxSync",
    "shareReferralLink",
    "paperIntake",
    "communityPaperIntake",
    "mailchimp",
    "constantContact",
    "clientCollaborators",
    "integrationKeyCollaborators",
    "webhooks",
    "twilioIntegration",
    "homeCarePrototype",
    "franchisePayments",
    "placement",
    "trackTime",
    "timeInStageReport",
    "agentChat",
    "unifiedMessagingTab",
    "wellSkyIntegration",
    "callTranscription",
    "referralPipelinesUnlimited",
    "marketingPlaybook",
    "marketingGoals",
    "contractPaymentSchedules",
    "employeeCommissions",
    "detailsPageVNext",
    "selfHostedMapTiles",
];
export var BillableEntitySource;
(function (BillableEntitySource) {
    BillableEntitySource["Explicit"] = "Explicit";
    BillableEntitySource["Upstream"] = "Upstream";
})(BillableEntitySource || (BillableEntitySource = {}));
export const tenantSkus = ["basic", "premium", "homeCare"];
export const tenantVerticals = ["placement", "homeCare"];
export var FeatureTrack;
(function (FeatureTrack) {
    FeatureTrack["Standard"] = "Standard";
    FeatureTrack["Beta"] = "Beta";
})(FeatureTrack || (FeatureTrack = {}));
export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["Disabled"] = "Disabled";
    FeatureStatus["Enabled"] = "Enabled";
    FeatureStatus["Beta"] = "Beta";
})(FeatureStatus || (FeatureStatus = {}));
export const featureMetadata = {
    clientReferralSourceView: {
        friendlyTitle: "Client Referral Source View",
        description: "Find clients via referral source owner",
        createdOn: "2021-11-01",
        intent: "setting",
    },
    discreteLicenseeField: {
        friendlyTitle: "DEPRECATED Licensee Field",
        description: "DEPRECATED - Use discreteLicenseRecords instead. (formerly: A separate licensee field that is searchable)",
        createdOn: "2022-01-31",
        intent: "rollout",
    },
    enhancedSentMessageView: {
        friendlyTitle: "Enhanced Sent Message View",
        description: "Display stats for sent messages",
        createdOn: "2022-03-25",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    discreteLicenseRecords: {
        friendlyTitle: "Discrete License Records",
        description: "Each community can have several licenses tracked",
        createdOn: "2022-08-31",
        intent: "rollout",
    },
    fax: {
        friendlyTitle: "Outbound fax",
        description: 'Send client intake via fax (Be sure to enable "Enhanced Sent Message View"/"enhancedSentMessageView" as well)',
        createdOn: "2022-10-19",
        intent: "packaging",
        skus: ["premium", "homeCare"],
    },
    customReportsDownload: {
        friendlyTitle: "Custom Reports Downloads",
        description: "Allow downloading custom report results",
        createdOn: "2023-01-24",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    customReportsSchedule: {
        friendlyTitle: "Custom Reports Scheduling",
        description: "Allow emailing custom report results on a schedule",
        createdOn: "2023-05-30",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    customReportsUnlimitedSave: {
        friendlyTitle: "Custom Reports Unlimited Save",
        description: "Allow saving more than 1 custom report",
        createdOn: "2023-05-18",
        intent: "packaging",
        packageEnabled: true,
        skus: ["premium", "homeCare"],
    },
    clientDisclosures: {
        friendlyTitle: "Client Disclosures",
        description: "Email automation and tracking for client disclosures",
        createdOn: "2022-11-16",
        intent: "packaging",
        skus: ["premium"],
    },
    hostedIntakeFormCustomizable: {
        friendlyTitle: "Hosted Intake Form with Customization",
        description: "Customize the hosted intake form with custom questions",
        createdOn: "2023-05-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    hostedIntakeFormUnlimited: {
        friendlyTitle: "Multiple Hosted Intake Forms",
        description: "Create and host multiple intake forms",
        createdOn: "2024-06-18",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    hostedIntakeFormExisting: {
        friendlyTitle: "Hosted Intake Form - Existing Clients",
        description: "Allow hosted intake form to be used for existing clients",
        createdOn: "2023-05-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    signwiseUnlimited: {
        friendlyTitle: "SignWise Unlimited Add-on",
        description: "Removes signature template limit for SignWise",
        createdOn: "2023-05-05",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    workflows: {
        friendlyTitle: "Workflows",
        description: "Allows user-created workflows",
        createdOn: "2023-05-09",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    integrationAccounts: {
        friendlyTitle: "Integration Accounts",
        description: "Allows user-created integration accounts for API integrations",
        createdOn: "2023-10-18",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: false,
    },
    customRoles: {
        friendlyTitle: "Custom Roles",
        description: "Allows users to be created with custom permission sets",
        createdOn: "2023-10-25",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    customizeClientStatus: {
        friendlyTitle: "Customize Client Status",
        description: "Allows users to create custom client statuses",
        createdOn: "2024-03-07",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    quickbooks: {
        friendlyTitle: "QuickBooks Integration",
        description: "Allows users to integrate with QuickBooks",
        createdOn: "2024-03-12",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    simpleSearch: {
        friendlyTitle: "Simple Search",
        description: "Allows users to search sitewide",
        createdOn: "2024-06-24",
        intent: "rollout",
    },
    mailboxSync: {
        friendlyTitle: "Mailbox Sync",
        description: "Sync your mailbox to Senior Place",
        createdOn: "2025-04-17",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: false,
    },
    shareReferralLink: {
        friendlyTitle: "Share Referral Link",
        description: "Share a referral link",
        createdOn: "2025-05-06",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    paperIntake: {
        friendlyTitle: "Paper Intake",
        description: "Allows users to upload paper intake forms to create and/or updateclients",
        createdOn: "2025-06-17",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    communityPaperIntake: {
        friendlyTitle: "Community Paper Intake",
        description: "Allows users to upload paper intake forms to create and/or update communities",
        createdOn: "2025-06-25",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    mailchimp: {
        friendlyTitle: "Mailchimp Integration",
        description: "Allows users to integrate with Mailchimp",
        createdOn: "2025-07-03",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    constantContact: {
        friendlyTitle: "Constant Contact Integration",
        description: "Allows users to integrate with Constant Contact",
        createdOn: "2025-08-06",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    hostedIntakeFormFileUpload: {
        friendlyTitle: "Hosted Intake Form - File Upload",
        description: "Allow file uploads during hosted intake form submission",
        createdOn: "2025-07-02",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: true,
    },
    clientCollaborators: {
        friendlyTitle: "Client Collaborators",
        description: "Allow users to collaborate on clients not assigned to them",
        createdOn: "2025-09-04",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    integrationKeyCollaborators: {
        friendlyTitle: "Integration Key Collaborators",
        description: "Allow integration key users to be added as collaborators on clients",
        createdOn: "2026-07-14",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    webhooks: {
        friendlyTitle: "Webhooks",
        description: "Receive real-time notifications when events occur in your account",
        createdOn: "2025-10-01",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    twilioIntegration: {
        friendlyTitle: "Twilio Integration",
        description: "Allows users to integrate with Twilio for SMS and voice calls",
        createdOn: "2025-11-25",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    homeCarePrototype: {
        friendlyTitle: "Home Care Prototype",
        description: "Enables the Home Care Client pipeline and related functionality",
        createdOn: "2026-03-03",
        intent: "packaging",
        skus: ["homeCare"],
        packageEnabled: true,
    },
    franchisePayments: {
        friendlyTitle: "Franchise Payments",
        description: "Enables inter-office split routing on invoices between franchise regions",
        createdOn: "2026-06-04",
        intent: "setting",
    },
    placement: {
        friendlyTitle: "Placement",
        description: "Enables the placement pipeline, community search, and related functionality",
        createdOn: "2026-03-09",
        intent: "packaging",
        skus: ["basic", "premium"],
        packageEnabled: true,
    },
    trackTime: {
        friendlyTitle: "Time Tracking",
        description: "Track billable hours per client with timer and manual entry",
        createdOn: "2026-03-23",
        intent: "packaging",
        skus: ["premium"],
        packageEnabled: false,
    },
    timeInStageReport: {
        friendlyTitle: "Time in Stage Report",
        description: "Report showing how long clients spend in each pipeline stage",
        createdOn: "2026-03-31",
        intent: "rollout",
    },
    agentChat: {
        friendlyTitle: "AI Agent Chat",
        description: "AI-powered chat assistant for searching and updating CRM data",
        createdOn: "2026-04-01",
        intent: "setting",
    },
    unifiedMessagingTab: {
        friendlyTitle: "Unified Messaging tab",
        description: "Modernized inbox column + read-pane layout on the global Messaging dashboard",
        createdOn: "2026-05-05",
        intent: "rollout",
    },
    wellSkyIntegration: {
        friendlyTitle: "WellSky Personal Care Integration",
        description: "Send home care clients to WellSky Personal Care as new prospects",
        createdOn: "2026-04-29",
        intent: "setting",
    },
    callTranscription: {
        friendlyTitle: "Call Recording",
        description: "Records outgoing voice calls and attaches them to the call activity",
        createdOn: "2026-05-22",
        intent: "rollout",
    },
    referralPipelinesUnlimited: {
        friendlyTitle: "Referral Pipelines Unlimited Add-on",
        description: "Removes the referral pipeline count limit",
        createdOn: "2026-06-12",
        intent: "packaging",
        skus: ["premium", "homeCare"],
        packageEnabled: true,
    },
    marketingPlaybook: {
        friendlyTitle: "Marketing Playbook",
        description: "Per-tier touchpoint cadences and a marketer dashboard of referral sources due for outreach",
        createdOn: "2026-06-17",
        intent: "rollout",
    },
    marketingGoals: {
        friendlyTitle: "Marketing Goals",
        description: "Admin-set monthly marketer goals across touchpoint activity and referral/care-start outcomes, with attainment tracking",
        createdOn: "2026-07-01",
        intent: "rollout",
    },
    contractPaymentSchedules: {
        friendlyTitle: "Contract Payment Schedules",
        description: "Multi-payment contract schedules on communities and invoice prefill from contract terms",
        createdOn: "2026-07-08",
        intent: "rollout",
    },
    employeeCommissions: {
        friendlyTitle: "Employee Commissions",
        description: "Enables tracking commissions owed to team members on invoice payments",
        createdOn: "2026-07-21",
        intent: "setting",
    },
    detailsPageVNext: {
        friendlyTitle: "Details Page vNext",
        description: "Redesigned entity detail pages: contact details and an Edit details panel at the top of the page",
        createdOn: "2026-07-31",
        intent: "rollout",
    },
    selfHostedMapTiles: {
        friendlyTitle: "Self-hosted Map Tiles",
        description: "Render maps from Senior Place basemap tiles instead of MapTiler",
        createdOn: "2026-08-07",
        intent: "rollout",
    },
};
//# sourceMappingURL=features.js.map